<template>
  <v-card class="w-100 pa-5 px-16" dir="ltr">
    <v-row>
      <v-col
        v-for="key in keys"
        :key="key"
        :cols="key === 'productionRate' ? '3' : '2'"
      >
        <div class="flex-row-start-center gap-2">
          <div class="text-body-2 mainBlue--text">
            {{ key === "interval" ? "Interval" : $t(key) }}:
          </div>
          <div class="text-body-2 text--text">
            {{ predictionData[key] }}
            {{
              key === "interval"
                ? "hours"
                : key === "productionRate"
                ? "t/h"
                : "%"
            }}
          </div>
        </div>
      </v-col>
      <v-col cols="3" dir="rtl">
        <div class="flex-row-start-center gap-2">
          <div class="text-body-2 text--text">{{ $t("dateTime") }}:</div>
          <div class="text-body-2 text--text">
            {{ time }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "jalali-moment";

export default {
  name: "PredictionHistoryCard",

  props: {
    predictionData: { type: Object, required: true },
  },

  data() {
    return {
      keys: ["carbon", "metallization", "productionRate", "interval"],
    };
  },

  computed: {
    time() {
      return moment(this.predictionData.time).format("jDD jMMMM jYYYY - hh:mm");
    },
  },
};
</script>
